import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import { LoadingBar } from '@appbase/components/loading'
import NoData from '@webparts/components/common/NoData.vue'
import ShortcutMoreModal from './ShortcutMoreModal.vue'
import ShortcutSettingModal from './ShortcutSettingModal.vue'
import { mapGetters } from 'vuex'

import api from '@webparts/api';
import * as accouttypes from '@account/store/types'
import * as urlHelper from '@appbase/util/url-helper'
import { buildStyle } from "@appbase/util/popup-helper"

import SubtleRSA from '@appbase/util/subtle-rsa'
import { replaceUserKeyword } from '@appbase/util'

const tempData: kyobobook.Shortcut[] = [
    {
        shortcutId: 1,
        webpartId: '',
        title: '노동조합',
        titleEn: 'Shortcut1',
        image: '/cm/gres/faux/images/portal/shortcut-icon01.png',
        linkUrl: 'https://www.google.com',
        order: 1,
        isUse: true,
        isMain: true,
        isPopup: false
    },
    {
        shortcutId: 2,
        webpartId: '',
        title: '임직원몰',
        titleEn: 'Shortcut2',
        image: '/cm/gres/faux/images/portal/shortcut-icon02.png',
        linkUrl: 'https://www.naver.com',
        order: 2,
        isUse: true,
        isMain: true,
        isPopup: false
    },
    {
        shortcutId: 3,
        webpartId: '',
        title: '회의실예약',
        titleEn: 'Shortcut3',
        image: '/cm/gres/faux/images/portal/shortcut-icon03.png',
        linkUrl: 'https://www.naver.com',
        order: 3,
        isUse: true,
        isMain: true,
        isPopup: false
    },
    {
        shortcutId: 4,
        webpartId: '',
        title: 'Clean Desk',
        titleEn: 'Shortcut4',
        image: '/cm/gres/faux/images/portal/shortcut-icon04.png',
        linkUrl: 'https://www.naver.com',
        order: 4,
        isUse: true,
        isMain: true,
        isPopup: false
    },
    {
        shortcutId: 5,
        webpartId: '',
        title: '명함신청',
        titleEn: 'Shortcut5',
        image: '/cm/gres/faux/images/portal/shortcut-icon05.png',
        linkUrl: 'https://www.naver.com',
        order: 5,
        isUse: true,
        isMain: true,
        isPopup: false
    },
    {
        shortcutId: 6,
        webpartId: '',
        title: '교보문고비전',
        titleEn: 'Shortcut6',
        image: '/cm/gres/faux/images/portal/shortcut-icon06.png',
        linkUrl: 'https://www.naver.com',
        order: 6,
        isUse: true,
        isMain: true,
        isPopup: false
    },
    {
        shortcutId: 7,
        webpartId: '',
        title: '사내규정',
        titleEn: 'Shortcut7',
        image: '/cm/gres/faux/images/portal/shortcut-icon07.png',
        linkUrl: 'https://www.naver.com',
        order: 7,
        isUse: true,
        isMain: true,
        isPopup: false
    },
    {
        shortcutId: 8,
        webpartId: '',
        title: '오늘의뉴스',
        titleEn: 'Shortcut8',
        image: '/cm/gres/faux/images/portal/shortcut-icon08.png',
        linkUrl: 'https://www.naver.com',
        order: 8,
        isUse: true,
        isMain: true,
        isPopup: false
    },
    {
        shortcutId: 9,
        webpartId: '',
        title: '고객의소리',
        titleEn: 'Shortcut9',
        image: '/cm/gres/faux/images/portal/shortcut-icon09.png',
        linkUrl: 'https://www.naver.com',
        order: 9,
        isUse: true,
        isMain: true,
        isPopup: false
    },
    {
        shortcutId: 10,
        webpartId: '',
        title: '새로고침',
        titleEn: 'Shortcut10',
        image: '/cm/gres/faux/images/portal/shortcut-icon10.png',
        linkUrl: 'https://www.naver.com',
        order: 10,
        isUse: true,
        isMain: true,
        isPopup: false
    },
];

@Component({
    name: 'kbb-shortcut-webpart',
    components: {
        LoadingBar,
        NoData,
        WebpartTemplate,
        ShortcutMoreModal,
        ShortcutSettingModal
    },
    computed: mapGetters({
        current: accouttypes.CURRENT,
    }),
})
export default class ShortcutWebpart extends Mixins(WebpartBase) {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) webpart!: webpartv3.Webpart

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    current!: account.TCurrent;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    options: any = null;

    shortcutList: kyobobook.Shortcut[] = [];
    useMore: boolean = false;
    useCategory: boolean = false;

    isShortcutManager: boolean = false;

    refRanNum: string = Math.floor(Math.random() * 1000).toString();
    partClass: string = '';

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    // 웹파트 옵션 저장값 set
    setProps() {
        this.options =
            typeof this.webpart.props == typeof '' ? JSON.parse(this.webpart.props as string) : this.webpart.props;
        this.useMore = this.options.useMore;
        this.useCategory = this.options.useCategory;
    }

    expandLinks() {
        if (this.preview) {
            return;
        } else {
            const modal: appbase.IModalOpenable = this.$refs['modal'] as any;
            const options: appbase.TModalInfo<any> = {
                component: ShortcutMoreModal,
                props: {
                    webpart: this.webpart,
                    useCategory: this.useCategory
                },
                events: {
                    cancel: () => {
                        modal.closeModal();
                    },
                },
            };
            modal.openModal(options);
        }
    }

    openSettingModal() {
        const modal: appbase.IModalOpenable = this.$refs['modal'] as any
        const options: appbase.TModalInfo<any> = {
            component: ShortcutSettingModal,
            props: { webpartId: this.webpart.id, useMore: this.options.useMore, useCategory: this.options.useCategory },
            events: {
                cancel: () => {
                    modal.closeModal()
                },
            },
        }
        modal.openModal(options)
    }

    async handleClick(link: kyobobook.Shortcut) {
        if (this.preview) return;

        if(link.shortcutId) this.addClickCount(link.shortcutId);

        var url = link.linkUrl;
        var features = ''
        var target = '_blank'

        if((/\$\{[A-Za-z0-9]+\}/g).test(url)){
            let urlReplaced = replaceUserKeyword(url, this.current.user);
            url = urlReplaced
        }

        if (url.includes('api/processToken')) {
            var _url = new URL(url)

            var searchParams = _url.searchParams

            var redirect = searchParams.get("redirectUrl") ?? "_blank"
            _url.searchParams.delete("redirectUrl")

            var search: string[] = []
            search.push(`personCode=${this.current.user.personCode}`, `timeStamp=${new Date().getTime()}`)
            if (_url.search !== '') {
                var _search = _url.search.slice(1).split('&')
                search = search.concat(_search)
            }
            var params = this.getParams(search)

            url = this.isTeams ? await urlHelper.redirectWithProcessToken(redirect, params, this.current.user.comCode, this.current.key)
                : `${window.location.origin}${process.env.NODE_ENV === 'production' ? '/po' : ''}${redirect}`;
            
            target = redirect
        } else if(url.includes('page/hmac')) {
            var _url = new URL(url);
            var searchParams = _url.searchParams;

            var redirect = searchParams.get("redirectUrl") ?? "";
            redirect = decodeURIComponent(redirect);
            _url.searchParams.delete("redirectUrl");

            const token = `personCode=${this.current.user.personCode}&actionUrl=${redirect}`;

            const rsa = new SubtleRSA(this.current.key);
            await rsa.initialize();
            const encrypted = await rsa.encrypt(token);

            url = `${window.location.origin}/cm/Kyobobook/redirect/page/hmac?token=${encodeURIComponent(encrypted)}`;
        } else if (url.includes('page/EmployeeMall')) {
            var _url = new URL(url);
            var searchParams = _url.searchParams;

            var redirect = searchParams.get("redirectUrl") ?? "";
            redirect = decodeURIComponent(redirect);
            _url.searchParams.delete("redirectUrl");

            const token = `personCode=${this.current.user.personCode}`;

            const rsa = new SubtleRSA(this.current.key);
            await rsa.initialize();
            const encrypted = await rsa.encrypt(token);

            url = `${window.location.origin}/cm/Kyobobook/redirect/page/EmployeeMall?token=${encodeURIComponent(encrypted)}`;
        } else if(url.includes('attendance')) {
            // 모듈이 분리된 근태관리 예외 처리
            var redirect = '/main';

            var search: string[] = [];
            search.push(`personCode=${this.current.user.personCode}`, `timeStamp=${new Date().getTime()}`);

            var params = this.getParams(search);

            url = this.isTeams ? await urlHelper.redirectWithProcessToken(redirect, params, this.current.user.comCode, this.current.key, 'attendance')
                : `${window.location.origin}/attendance${redirect}`;
            
            target = redirect
        }

        if(link.isPopup) features = buildStyle({ width: 910, height: 900 })

        window.open(url, target, features);    
    }

    getParams(search: string[]) {
        var res = ''

        for (var i = 0; i < search.length; i++) {
            res += `&${search[i]}`
        }

        if (res.startsWith('&'))
            res = res.slice(1)

        return res
    }

    addClickCount(shortcutId: number) {
        if(this.webpart.id) {
            api.kyobobook.addClickCount(this.webpart.id, shortcutId);
        }
    }

    load() {
        this.loading = true;

        if (this.current.permissions.roles.length > 0) {
            this.isShortcutManager = this.current.permissions.isCompanyManager || this.current.permissions.isSuperAdmin
            // this.current.permissions.roles.find(i=>i.roleType.toLowerCase()=='banner')!=undefined
        }

        if (this.webpart.id) {
            if (this.useMore) {
                api.kyobobook.getShortcutListByMain(this.webpart.id, true).then((res: any) => {
                    this.shortcutList = res;
                    this.loading = false;
                });
            } else {
                api.kyobobook.getShortcutList(this.webpart.id).then((res: any) => {
                    this.shortcutList = res;
                    this.loading = false;
                });
            }
        } else {
            this.loading = false;
        }
    }

    getShortcutImageSource(fileName: string) {
        return `/cm/Webpart/WebpartShortcut/api/KBB/getShortcutImage?fileName=${encodeURIComponent(fileName)}`;
    }

    getClass() {
        var targetElem = this.$refs[this.refRanNum] as HTMLElement;
        this.partClass = targetElem.clientWidth > 400 ? 'part-shortcut' : 'part-ehr'
    }

    getTitleSplit(title: string){
        return title.split('\n')
    }
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H E S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    @Watch('webpart.props')
    changeWebpartValue() {
        this.setProps();
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    created() {
        if (this.webpart && this.webpart.props) {
            this.setProps();
        }

        if (this.preview) {
            this.shortcutList = tempData;
        } else {
            this.load();
        }
    }

    mounted() {
        this.getClass();
    }
}
